/* eslint-disable @typescript-eslint/no-explicit-any */
import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import dayjs from 'dayjs';
import 'dayjs/locale/fr';
import React, {useCallback, useEffect, useState} from 'react';
import {View} from 'react-native';
import {connect} from 'react-redux';
import {nextDateEffect, toDate} from '../../../common/utils/date';
import {defaultValues} from '../../../data/constants/Assurance/assuranceRCVP';
import {thousandSeparator} from '../../../data/factory';
import {mapAgence} from '../../../data/factory/agence';
import {ApiResponse} from '../../../data/types/interface/api';
import {StackParams} from '../../../data/types/navigation';
import {ContratServices} from '../../../services/applicatif/contrat';
import mapDispatchToProps from '../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../services/redux/mapStateToProps';
import {HeaderScreen} from '../../components/Header/HeaderScreen';
import {Header} from '../../components/Header/HeaderSouscriptionRCVP';
import {Loader} from '../../components/Loader';
import ConfirmationModal from '../../components/Modal/ConfirmationModal';
import {PageContainer} from '../../components/PageContainer';
import {Form} from './Forms/FormWeb';

type NavigationProps = StackNavigationProp<
  StackParams,
  'SouscriptionAssuranceRCVPForm'
>;

const data = {
  ...defaultValues,
};

const FSouscriptionAssuranceRCVPForm = (props: any) => {
  const {
    contratEnCoursUser,
    checkOrangeTransactionUser,
    checkTelmaTransactionUser,
  } = props;
  const {navigate, goBack} = useNavigation<NavigationProps>();
  const [listAgence, setListAgence] = useState<any>([]);
  const [dataDto, setDataDto] = useState(data);
  const [postSucces, setPostSuccess] = useState(false);
  const [IsLoading, setIsLoading] = useState(false);
  const {getAgence, rcvpContrat, user, getDetailTypeassurance} = props;
  const {getDetailContrat} = ContratServices();
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [minDateEffect, setMinDateEffect] = useState(new Date());
  const isRenewal =
    props.route.params && props.route.params.typeAssurance == 'renouvellement';
  const typeId = props.route.params.typeId;
  const userId =
    user && user.data && user.data.utilisateur && user.data.utilisateur.id;
  const updateData = (user: any) => {
    dataDto.adresse = user.adresse;
    dataDto.emailContractant = user.email;
    dataDto.dateNaissanceContractant = user.dateNaissance;
    dataDto.nomPrenomContractant = `${user.nom} ${user.prenom}`;
    dataDto.telephoneContractant = user.telephone;
    dataDto.telephoneContractantCountryCode = user.countryCode;
    dataDto.dateEffet = dayjs().format('DD/MM/YYYY');
    return dataDto;
  };

  const updateDataPrime = useCallback(
    (prime: string) => {
      const _prime = thousandSeparator(prime, ' ');
      dataDto.primeTTC = _prime;
      return dataDto;
    },
    [dataDto.primeTTC],
  );

  useEffect(() => {
    if (user && user.data && user.data.utilisateur) {
      let _data = updateData(user.data.utilisateur);

      const _url = `?typeId=${typeId}&montant=true`;
      getDetailTypeassurance(
        {},
        (res: ApiResponse) => {
          if (res && !res.isError && res.data) {
            _data = updateDataPrime(res.data.toString());
          }
        },
        _url,
      );
      setDataDto(_data);
    }
  }, [user]);

  useEffect(() => {
    checkOrangeTransactionUser('echoue', () => {});
    checkTelmaTransactionUser('echoue', () => {});
    setIsLoading(true);
    getAgence({}, (res: ApiResponse) => {
      if (res && !res.isError && res.data && res.data.items) {
        const _list = mapAgence(res.data.items);
        setListAgence(_list);
        if (isRenewal) {
          getDetailContrat(props.user.numeroPolice)
            .then(res => {
              const contrat = res.data;
              const _minDateEffect = nextDateEffect(
                contrat.versions[0].dateEcheance,
              );
              setMinDateEffect(toDate(_minDateEffect));
              setDataDto({
                ...dataDto,
                agence: contrat.agence,
                dateEffet: _minDateEffect,
                nombreAnimauxDomestique:
                  contrat.nombreAnimauxDomestique.toString(),
              });
            })
            .finally(() => setIsLoading(false));
        } else {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    });
  }, []);

  const handleCancel = useCallback(() => {
    goBack();
  }, [goBack]);

  const handleSubmit = (response: any) => {
    const _data = {...response};
    setIsLoading(true);
    rcvpContrat(
      {
        ...response,
        operationType: 'simulation',
        simulationId: '',
        utilisateur: userId,
      },
      (res: ApiResponse) => {
        setIsLoading(false);
        if (res && !res.isError && res.data) {
          _data.dateNaissanceContractant = toDate(
            response.dateNaissanceContractant,
          );
          //add dateEffet
          _data.dateEffet = toDate(response.dateEffet);
          setDataDto(_data);
          const _reponse = {
            ...response,
            operationType: 'create',
            simulationId: res.data,
            utilisateur: userId,
            dateEffet: _data.dateEffet,
          };
          contratEnCoursUser({
            numeroPolice: isRenewal ? props.user.numeroPolice : undefined,
            typeContrat: 'rcvp',
            typePayment: isRenewal ? 'renouvellement' : 'souscription',
            ..._reponse,
          });
          setPostSuccess(true);
        } else {
          setErrorMessage(res.message);
          setShowErrorModal(true);
        }
      },
    );
  };

  const redirectToPayment = () => {
    setPostSuccess(false);
    navigate('Payement');
  };

  return (
    <View>
      <HeaderScreen
        title={isRenewal ? 'Renouvellement' : 'Souscription'}
        type="retour"
        noBreadcrumb={false}
      />
      <PageContainer>
        {postSucces && (
          <ConfirmationModal
            title="Assurance RCVP"
            content={`Pour finaliser votre ${
              isRenewal ? 'renouvellement' : 'souscription'
            }, veuillez procéder au paiement.`}
            btn1="OK"
            handleBtn1={redirectToPayment}
          />
        )}
        {showErrorModal && (
          <ConfirmationModal
            title="Erreur"
            content={errorMessage}
            btn1="OK"
            handleBtn1={() => setShowErrorModal(false)}
          />
        )}
        {/** Loading */}
        {IsLoading && <Loader />}
        {/** Header content */}
        {!IsLoading && !postSucces && !showErrorModal && (
          <Header isRenewal={isRenewal} />
        )}
        {/** Form content */}
        {!postSucces && !IsLoading && !showErrorModal && (
          <Form
            data={dataDto}
            listAgence={listAgence}
            isRenewal={isRenewal}
            minDateEffect={minDateEffect}
            onCancelForm={handleCancel}
            onSubmitForm={handleSubmit}
          />
        )}
      </PageContainer>
    </View>
  );
};

export const SouscriptionAssuranceRCVP = connect(
  mapStateToProps,
  mapDispatchToProps,
)(FSouscriptionAssuranceRCVPForm);
